var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFBene2Cp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Dise\xF1o",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    fill: "#4a46ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Flag",
    d: "M56.55,37.38l6.56-6.56c.57-.57.74-1.43.43-2.17-.31-.75-1.03-1.23-1.84-1.23h-25.89c0-1.1-.89-1.99-1.99-1.99s-1.99.89-1.99,1.99v35.85c0,1.1.89,1.99,1.99,1.99s1.99-.89,1.99-1.99v-15.94h25.89c.81,0,1.53-.48,1.84-1.23.31-.75.14-1.6-.43-2.17l-6.56-6.56Z",
    fill: "#4a46ab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFBene2Cp);
export default __webpack_public_path__ + "static/media/F-Bene2-CP.537554c406287aab6e951f66b054a744.svg";
export { ForwardRef as ReactComponent };